import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  AnalyticsService,
  DataService,
  LoansService,
  OperationsService,
  OptionsserviceService,
  StorageService
} from '../../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';

@Component({
  selector: 'app-others',
  templateUrl: './others.component.html',
  styleUrls: ['./others.component.css']
})
export class OthersComponent implements OnInit {
  view: any = 'data';
  title = 'Other Analytics';
  @Input('details') details: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;
  token: any;
  @Input('parentRouteId') parentRouteId: any;
  loan: any;
  selected_analytics = '2';
  nodesandscores: any;
  analytics_result: any;
  sub: any;
  currentUser: any;
  data: any;
  text = 'Call logs Analytcis';
  average_monthly_cost = 0;
  average_calls_per_month = 0;
  nodes_and_scores: any;
  analytics_last_done = '';
  snapshot: any;
  showPicture = false;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  passed_analytics: any;
  failed_analytics: any;
  number_passed: number;
  number_failed: number;
  analytics_score: number;
  sms_value: any;
  guarantor_value: any ;
  call_logs_value: any;
  cards_value: any;
  profile_value: any;
  social_value: any;
  accounts_value: any;
  dd_value: any;
  repayment_value: any;
  guarantor_analytics_passed: any;
  guarantor_analytics_failed: any;
  card_analytics_passed: any;
  card_analytics_failed: any;
  account_analytics_passed: any;
  account_analytics_failed: any;
  dd_analytics_passed: any;
  dd_analytics_failed: any;
  params: any = JSON.parse(localStorage.getItem('params'));
  guarantor_status: boolean;
  card_status: boolean;
  account_status: boolean;
  dd_status: boolean;
  bvn_value: any;
  constructor(
    private http: HttpClient,
    private analyticsService: AnalyticsService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public router: Router,
    private _location: Location
  ) {
    this.guarantor_value = this.params.guarantor;
    this.accounts_value = this.params.account;
    this.cards_value = this.params.card;
    this.dd_value = this.params.direct_debit;
  }

  ngOnInit() {
    //this.getAnalytics();
    // this.getAnalyticsData();
  }
  getAnalytics() {
    return new Promise((resolve, reject) => {
      return this.http
        .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
          request_id: '13126'
        })
        .toPromise()
        .then(res => {
          //console.log(res);
          this.lender_id = res.lender_id;
          this.borrower_id = res.borrower_id;
          this.principal = res.principal;
          this.maturity_date = res.maturity_date;
          this.account_card_id = res.account_card_id;
          this.loan_request_id = res.loan_request_id;
          this.card_id = res.card_id;
          resolve();
        })
        .then(() => this.getFullAnalytics())
        .catch(err => {
          //console.log(err);
          // reject();
        });
    });
  }
  getFullAnalytics() {
    //console.log(this.lender_id);
    return this.analyticsService
      .getFullAnalytics(
        this.lender_id,
        this.borrower_id,
        this.principal,
        this.maturity_date,
        this.account_card_id,
        this.loan_request_id,
        this.card_id,
        this.sms_value,
        this.call_logs_value,
        this.profile_value,
        this.guarantor_value,
        this.cards_value,
        this.accounts_value,
        this.dd_value,
        this.repayment_value,
        this.social_value,
        {}
      )
      .subscribe(data => {
        this.guarantor_analytics_passed = data.description.guarantor.passed;
        this.guarantor_analytics_failed = data.description.guarantor.failed;
        this.card_analytics_passed =  data.description.card.passed;
        this.card_analytics_failed =  data.description.card.failed;
        this.account_analytics_passed =  data.description.account.passed;
        this.account_analytics_failed =  data.description.account.failed;
        this.dd_analytics_passed =  data.description.direct_debit.passed;
        this.dd_analytics_failed =  data.description.direct_debit.failed;
        this.analytics_score = data.final_analytics_score * 100;
        this.guarantor_status = data.status.guarantor;
        this.account_status = data.status.account;
        this.dd_status = data.status.direct_debit;
        this.card_status = data.status.card;
      });
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  // getAnalyticsData() {
  //   this.sub = this.route.params.subscribe(params => {
  //     this.parentRouteId = +params['id'];
  //     this.loansService
  //       .getOtherAnalyticsData(this.currentUser.token, this.parentRouteId)
  //       .subscribe(data => {
  //         this.loan = data.loan;
  //         this.guarantor_analytics_passed = data.loan.analytics_summary.customer_analysis.description.guarantor.passed;
  //       this.guarantor_analytics_failed = data.loan.analytics_summary.customer_analysis.description.guarantor.failed;
  //       this.card_analytics_passed =  data.loan.analytics_summary.customer_analysis.description.card.passed;
  //       this.card_analytics_failed =  data.loan.analytics_summary.customer_analysis.description.card.failed;
  //       this.account_analytics_passed =  data.loan.analytics_summary.customer_analysis.description.account.passed;
  //       this.account_analytics_failed = data.loan.analytics_summary.customer_analysis.description.account.failed;
  //       this.dd_analytics_passed =  data.loan.analytics_summary.customer_analysis.description.direct_debit.passed;
  //       this.dd_analytics_failed = data.loan.analytics_summary.customer_analysis.description.direct_debit.failed;
  //       this.analytics_score = data.loan.analytics_summary.customer_analysis.final_analytics_score * 100;
  //       this.guarantor_status = data.loan.analytics_summary.customer_analysis.status.guarantor;
  //       this.account_status = data.loan.analytics_summary.customer_analysis.status.account;
  //       this.dd_status = data.loan.analytics_summary.customer_analysis.status.direct_debit;
  //       this.card_status = data.loan.analytics_summary.customer_analysis.status.card;
  //
  //       });
  //   });
  // }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({
      section: section,
      request_id: this.parentRouteId
    });
  }
  saveAnalytics(event) {
    this.loansService
      .saveSMSAnalysisData(
        this.currentUser.token,
        this.parentRouteId,
        this.nodes_and_scores,
        this.data
      )
      .subscribe(data => {
        this.data = data.result;
        this.details = data.result;
        this.nodes_and_scores = data.nodes_and_scores;
        this.analytics_last_done = data.analytics_last_done;
        this.loan = data.loan;
      });
  }
  modifyAnalytics(event) {
    this.dataService.onEditApplicationsModal.emit({
      section: 'specific_analytics',
      request_id: this.parentRouteId,
      nodes_and_scores: this.nodes_and_scores,
      selected_analytics: '2',
      analytics_last_done: this.analytics_last_done,
      isedit: '1'
    });
  }
  goBack() {
    this._location.back();
  }
  doingDisbursement(event){

  }
}
